import { useAuth } from "@/lib/AuthContext";
import Layout from "./Layout";
import Dashboard from "@/pages/dashboard/page";
import MarketingHome from "@/pages/marketing/page";

export default function HomeGate() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="flex items-center gap-2 text-foreground-400 text-sm">
          <i className="ri-loader-4-line animate-spin text-base"></i>
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (user) {
    return (
      <Layout>
        <Dashboard />
      </Layout>
    );
  }

  return <MarketingHome />;
}
